import { SiteModel } from '@modules/site/site-model';

const { fields } = SiteModel;

export default [
  fields.id,
  fields.name,
  fields.createdAt
];
